import LeaveHTMLPreviewBalanceColumnsRender from './LeaveHTMLPreviewBalanceColumnsRender'

export default class LeaveHTMLPreviewBothBalanceColumnsRender extends LeaveHTMLPreviewBalanceColumnsRender {

    constructor(withSpaces) {
        super(withSpaces)
    }

    addHeaderFirstRowCells = (fRow) => {
        this._addEmptyCellIfNeed(fRow)
        this._addPTOFRowCells(fRow)
        this._addEmptyCellIfNeed(fRow)
        this._addSickDaysFRowCells(fRow)
    }

    addHeaderSecondRowCells = (sRow) => {
        this._addEmptyCellIfNeed(sRow)
        this._addRangeSRowCells(this.showPTOInHours, sRow)
        this._addEmptyCellIfNeed(sRow)
        this._addRangeSRowCells(this.showSickInHours, sRow)
    }

    addValueCells = (row) => {
        this._addEmptyCellIfNeed(row)
        this._addBalanceValueCell(row)
        this._addBalanceValueCell(row)
        this._addEmptyCellIfNeed(row)
        this._addBalanceValueCell(row)
        this._addBalanceValueCell(row)
    }

    getRenderSpecificCssClass = () => {
        return "bothBalances"
    }
}





// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewBothBalanceColumnsRender.js